module.exports = __webpack_public_path__ + "img/server-other-phone-icon.28ace7ff.svg";